export type VideoSource = {
  src: string;
  type: string;
};

const preloadedVideos = new Map<string, HTMLVideoElement>();

export const preloadVideoSources = (sources: readonly VideoSource[]) => {
  if (typeof document === 'undefined' || sources.length === 0) {
    return;
  }

  const key = sources.map(({ src, type }) => `${type}:${src}`).join('|');
  if (preloadedVideos.has(key)) {
    return;
  }

  const video = document.createElement('video');
  video.muted = true;
  video.playsInline = true;
  video.preload = 'auto';

  sources.forEach(({ src, type }) => {
    const source = document.createElement('source');
    source.src = src;
    source.type = type;
    video.appendChild(source);
  });

  preloadedVideos.set(key, video);
  video.load();
};
